import PropertyFeatures from "components/Developer/Property/property-features";
import React from "react";
import utilitiesIcon from "../../../../assets/icons/utilities.svg";
import entertainmentIcon from "../../../../assets/icons/entertainment.svg";
import kitchenIcon from "../../../../assets/icons/kitchen.svg";
import safetyIcon from "../../../../assets/icons/safety.svg";
import othersIcon from "../../../../assets/icons/others.svg";

const Offers = ({ property }: any) => {
  return (
    <>
      {(property?.utilitiesAndAmenities?.length > 0 ||
        property?.kitchenAndDining?.length > 0 ||
        property?.entertainment?.length > 0 ||
        property?.safety?.length > 0 ||
        property?.otherFeatures?.length > 0) && (
          <div>
            <h5 className="my-4">What this place offers</h5>
            <div className="project-details gap-3 border rounded-4 p-3">
              {property.utilitiesAndAmenities &&
                property.utilitiesAndAmenities.length > 0 && (
                  <PropertyFeatures
                    title="Utilities and Amenities"
                    icon={utilitiesIcon}
                    items={property.utilitiesAndAmenities}
                  />
                )}
              {property.entertainment && property.entertainment.length > 0 && (
                <PropertyFeatures
                  title="Entertainment"
                  icon={entertainmentIcon}
                  items={property.entertainment}
                />
              )}
              {property.kitchenAndDining &&
                property.kitchenAndDining.length > 0 && (
                  <PropertyFeatures
                    title="Kitchen and Dining"
                    icon={kitchenIcon}
                    items={property.kitchenAndDining}
                  />
                )}
              {property.safety && property.safety.length > 0 && (
                <PropertyFeatures
                  title="Safety"
                  icon={safetyIcon}
                  items={property.safety}
                />
              )}
              {property.otherFeatures && property.otherFeatures.length > 0 && (
                <PropertyFeatures
                  title="Other Features"
                  icon={othersIcon}
                  items={property.otherFeatures}
                />
              )}
            </div>
          </div>
        )}
    </>
  );
};

export default Offers;
